import React from 'react';

const PlayButtonBannerIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.918 47.8504V10.1504L48.3346 29.0004L16.918 47.8504Z"
            fill="#010101"
        />
    </svg>
);

export {PlayButtonBannerIcon};
